import { message } from "antd";
import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";

import get from "lodash/get";
import { setActionItem, setNotificationMessage } from "../home/action";
import {
  addingNewCategory,
  addNewCategoryError,
  getAllCategoriesError,
  getPageCategoriesError,
  gettingAllCategories,
  gettingPageCategories,
  newCategoryAdded,
  setAllCategories,
  setPageCategories,
  setAllSubCategories,
  getCategoryRating1,
  setAllCertificates,
  getAllCategories,
  setCurrentCategoryTab,
} from "./action";
import {
  ADD_NEW_CATEGORY,
  GET_ALL_CATEGORIES,
  GET_PAGE_CATEGORIES,
  GET_CATEGORY_REVIEW,
  UPDATE_CATEGORY,
} from "./types";

const { createLogic } = require("redux-logic");

const addNewCategoryLogic = createLogic({
  type: ADD_NEW_CATEGORY,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(addingNewCategory());
    const formData = new FormData();
    const {
      name,
      shortDescription,
      longDescription,
      profilePic,
      parentId,
      certificates,
      services
    } = action.payload;

    name && formData.append("name", name);
    shortDescription && formData.append("shortDescription", shortDescription);
    longDescription && formData.append("longDescription", longDescription);
    profilePic && formData.append("profilePic", profilePic);
    certificates && certificates.length && formData.append("certificate", JSON.stringify({ certificates }));
    services && services.length && formData.append("service", JSON.stringify({ services }));
    if (parentId) formData.append("parentId", parentId);
    const token = getItem("token");
    formData.append("authToken", token ? token : "");

    Service({
      method: "post",
      url: API_ROUTES.ADD_CATEGORY,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        dispatch(newCategoryAdded());
        dispatch(setNotificationMessage({ type: "success", message: action?.message }));
        dispatch(setCurrentCategoryTab(parentId ? "2" : "1"))
        dispatch(setActionItem("CATEGORY_VIEW", "VIEW"));
        done();
      })
      .catch((err) => {
        dispatch(addNewCategoryError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const editCategory = createLogic({
  type: UPDATE_CATEGORY,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(addingNewCategory());
    const formData = new FormData();
    const {
      id,
      name,
      shortDescription,
      longDescription,
      profilePic,
      parentId,
      certificates,
      services, category
    } = action.payload;
    formData.append("id", id)
    name && formData.append("name", name);
    shortDescription && formData.append("shortDescription", shortDescription);
    longDescription && formData.append("longDescription", longDescription);
    profilePic && formData.append("profilePic", profilePic);
    certificates && certificates.length && formData.append("certificate", JSON.stringify({ certificates }));
    services && services.length && formData.append("service", JSON.stringify({ services }));
    if (parentId) formData.append("parentId", parentId);
    const token = getItem("token");
    formData.append("authToken", token ? token : "");

    Service({
      method: "post",
      url: API_ROUTES.EDIT_CATEGORY,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        // dispatch(newCategoryAdded());
        if (category) {
          dispatch(getAllCategories(category));
        }
        dispatch(setCurrentCategoryTab(parentId ? "2" : "1"))
        dispatch(setNotificationMessage({ type: "success", message: action?.message }));
        dispatch(setActionItem("CATEGORY_VIEW", "VIEW"));
        done();
      })
      .catch((err) => {
        dispatch(addNewCategoryError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getAllCategoriesLogic = createLogic({
  type: GET_ALL_CATEGORIES,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(gettingAllCategories());
    const parentId = action.payload?.subCategory ? action.payload?.subCategory : action.payload;
    const authToken = getItem("token");

    const payload = { authToken: authToken ? authToken : "", parentId };
    // axios.post(API_ROUTES.GET_CATEGORIES, payload, {
    //     // headers: { "Content-Type": "multipart/form-data" },
    // });
    Service({
      method: "post",
      url: API_ROUTES.GET_CATEGORIES,
      data: { ...payload },
    })
      .then((res) => {
        const list = get(res, "data.data.list", []);
        if (action.payload?.subCategory) {
          dispatch(setAllCertificates(list));
        } else {
          if (action.payload) {
            dispatch(setAllSubCategories(list));
          } else {
            dispatch(setAllCategories(list));
          }
        }
        done();
      })
      .catch((err) => {
        dispatch(getAllCategoriesError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const getPageCategoriesLogic = createLogic({
  type: GET_PAGE_CATEGORIES,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(gettingPageCategories());

    const authToken = getItem("token");
    const payload = { authToken: authToken ? authToken : "" };

    Service({
      method: "post",
      url: API_ROUTES.GET_PAGINATED_CATEGORIES(action.payload),
      data: { ...payload },
    })
      .then((res) => {
        const paginatedCategories = get(res, "data.data", {});
        dispatch(
          setPageCategories({
            ...paginatedCategories,
            requestedPage: action.payload,
          })
        );
        done();
      })
      .catch((err) => {
        dispatch(getPageCategoriesError(err));
        dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
        done();
      });
  },
});

const dynamicPayload = (data, auth) => {
  switch (data.payload.typeName) {
    case "category":
      return { authToken: auth ? auth : "", categoryId: data.payload.value };
    case "subCategory":
      return { authToken: auth ? auth : "", categoryId: data.payload.value };
    case "customer":
      return { authToken: auth ? auth : "", userId: data.payload.value };
    case "admin":
      return { authToken: auth ? auth : "", userId: data.payload.value };
    case "superAdmin":
      return { authToken: auth ? auth : "", userId: data.payload.value };
    case "serviceProvider":
      return { authToken: auth ? auth : "", userId: data.payload.value };
    default:
      break;
  }
};

const getCategoryReviewsInfoLogic = createLogic({
  type: GET_CATEGORY_REVIEW,
  latest: true,
  process({ action }, dispatch, done) {
    dispatch(getCategoryRating1());
    const authToken = getItem("token");
    let payload;
    if (action.payload?.own && action.payload?.own === true) {
      payload = { authToken: authToken ? authToken : "" };
    } else {
      payload = dynamicPayload(action, authToken);
    }

    // Service({
    //     method: "post",
    //     url: API_ROUTES.GET_CATEGORY_RATING,
    //     data: { ...payload },
    // })
    //     .then((res) => {
    //         const list = res
    //         if (action.payload) dispatch(getCategoryRating1(list));
    //         done();
    //     })
    //     .catch((err) => {
    //         dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
    //         done();
    //     });
  },
});

export default [
  addNewCategoryLogic,
  editCategory,
  getAllCategoriesLogic,
  getPageCategoriesLogic,
  getCategoryReviewsInfoLogic,
];
